module.exports = __webpack_public_path__ + "static/media/side-extra.df17ff15.svg";